import React, { FC } from 'react';
import { SearchResultDTOTypeEnum } from '@atlassiansox/phobos-client-ts';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import Button from '@atlaskit/button';

import { flexStart, spaceGapMinimum, tableExpandButtonStyles } from '@/styles';
import { noop } from '@/utils';

import { testIds } from '../../constants';

type SearchListTypeProps = {
  type: SearchResultDTOTypeEnum;
  isCardExpanded: boolean;
  hideType?: boolean;
};

const SearchListType: FC<SearchListTypeProps> = ({ type, isCardExpanded, hideType = false }) => (
  <div css={[flexStart]}>
    <span css={tableExpandButtonStyles}>
      <Button
        spacing="none"
        appearance="subtle"
        onClick={noop}
        testId={testIds.searchResultListTitleAction}
      >
        {isCardExpanded && <ChevronDownIcon size="medium" label="" />}
        {!isCardExpanded && <ChevronRightIcon size="medium" label="" />}
      </Button>
    </span>
    {!hideType && <span css={[flexStart, spaceGapMinimum]}>{type.replace(/_/gi, ' ')}</span>}
  </div>
);

export default SearchListType;
